import { Card, Space, Statistic } from 'antd';
import styles from './distribution-cost-aggregated-statistic.module.scss';
import type { IDistributionCostAggregatedStatisticProps } from './types';

export const DistributionCostAggregatedStatistic = (props: IDistributionCostAggregatedStatisticProps) => {
  const { distributionCost, totalLdm, costPerLdm } = props;

  return (
    <Space size='middle' className={styles.container} wrap>
      <Card>
        <Statistic title='Distribution cost' value={distributionCost} suffix='EUR' precision={2} />
      </Card>
      <Card>
        <Statistic title='Total LDM' value={totalLdm} suffix='LDM' precision={2} />
      </Card>
      <Card>
        <Statistic title='Eur/LDM' value={costPerLdm} precision={2} />
      </Card>
    </Space>
  );
};
